import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { authGuard } from '../services/AuthGuard';
import { Layout } from './layout/layout';
import { PageNotFound } from './page-not-found';
import { HrEmployeesIndex } from './hr/employees/hr.employees.index';
import { HrPositionsIndex } from './hr/positions/hr.positions.index';

export const routes: Routes = [
  {
    path: '', component: Layout, children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
      {
        path: 'hr', children: [
          { path: 'employees', component: HrEmployeesIndex },
          { path: 'positions', component: HrPositionsIndex },
        ],
        canActivate: [authGuard]
      },
      {
        path: 'service', children: [
          { path: 'lite_schedule', loadChildren: () => import('./service/lite_schedule/routes').then(r => r.routes) },
          { path: 'tasks', loadChildren: () => import('./service/tasks/routes').then(r => r.routes) },
          // {path: 'manageusers', loadChildren: ()=>import('./service/manageusers/routes').then(r=>r.routes)},
        ]
      }
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LoginComponent, data: { logout: true } },
  { path: '**', component: PageNotFound }
];
